import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    overflowX: 'auto',
    overflow: 'hidden',
    border: '2px solid #EFF1FF',
    borderRadius: 16
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  headerCell: {
    background: theme.palette.background.paper,
    color: theme.palette.secondary.dark,
    fontWeight: 700,
    textAlign: 'center',
    padding: '16px',
    verticalAlign: 'middle',
    borderBottom: '2px solid #EFF1FF',

    '&:not(:last-child)': {
      borderRight: '2px solid #EFF1FF'
    }
  },
  cell: {
    background: '#FDFDFF',
    padding: '16px',
    fontSize: 14,
    lineHeight: '20px',
    verticalAlign: 'middle',
    textAlign: 'left',
    borderBottom: '2px solid #EFF1FF',

    '&:not(:last-child)': {
      borderRight: '2px solid #EFF1FF'
    }
  },
  centerCell: {
    textAlign: 'center'
  },
  highlightRow: {
    '& td': {
      fontWeight: 700
    }
  },
  lastRow: {
    '& td': {
      borderBottom: 'none'
    }
  }
}))
